import { TABLET_API_ORIGIN } from '@/global/env';

const name = {
  key: 'name',
  label: '拠点名',
  question: '住所のある実店舗名',
} as const;
const password = { key: 'password', label: 'パスワード' } as const;
const confirmPassword = {
  key: 'confirmPassword',
  label: 'パスワード（確認用）',
} as const;
const email = {
  key: 'email',
  label: '拠点メールアドレス',
  question: 'Camel受注画面にログインする際に使用するメールアドレス',
} as const;
const phoneNumber = {
  key: 'phoneNumber',
  label: '電話番号',
  question: undefined,
} as const;
const zipCode = { key: 'zipCode', label: '郵便番号' } as const;
const prefecture = { key: 'prefecture', label: '都道府県' } as const;
const city = { key: 'city', label: '市区町村' } as const;
const streetAddress = { key: 'streetAddress', label: '町域以下' } as const;
const building = { key: 'building', label: '建物名・号室' } as const;
const associateBrand = { key: 'associateBrand', label: 'ブランド名' } as const;
const latitude = {
  key: 'latitude',
  label: '緯度',
  question: undefined,
} as const;
const longitude = {
  key: 'longitude',
  label: '経度',
  question: undefined,
} as const;

export const authStoreForm = {
  name,
  email,
  password,
  confirmPassword,
  phoneNumber,
  zipCode,
  prefecture,
  city,
  streetAddress,
  building,
  associateBrand,
  latitude,
  longitude,
} as const;

// NOTE: テーブルのカラムにだけ必要 (フォームには必要無い)
const address = { label: '住所', question: undefined };

const tableColumns = [
  {
    ...name,
    width: '200px',
  },
  {
    ...email,
    width: '200px',
  },
  { ...phoneNumber, width: '200px' },
  { ...address, width: '220px' },
  { ...latitude, width: '70px' },
  { ...longitude, width: '70px' },
] as const;

export const authStoreTableThs = tableColumns.map((tableColumn) => {
  return {
    label: tableColumn.label,
    minWidth: tableColumn.width,
    question: tableColumn.question,
  };
});

export const storeProxyLoginTh = {
  label: 'タブレット画面',
  minWidth: '140px',
  question: undefined,
};

// 代理ログイン発行APIはタブレットのCookieに代理ログイン用トークンをセットしてタブレット画面へリダイレクトするため、
// このURLはブラウザの遷移で開くリンクに使います。
export const storeProxyLoginUrl = (authStoreId: number): string =>
  `${TABLET_API_ORIGIN}/dashboard-api/auth-stores/${authStoreId}/proxy-login`;

export type GeoLocation = {
  latitude: number | null;
  longitude: number | null;
};

export const isEqualGeoLocation = (
  geoLocation1: GeoLocation,
  geoLocation2: GeoLocation
): boolean => {
  return (
    geoLocation1.latitude === geoLocation2.latitude &&
    geoLocation1.longitude === geoLocation2.longitude
  );
};
